import { carousel, grid, post_thumbnails, slider } from '../../../utils/icons';

export const layoutItem = [
    {
        icon: slider,
        title: "Default",
        layoutType: "default",
    },
    {
        icon: carousel,
        title: "Carousel",
        layoutType: "carousel",
    },
    {
        icon: grid,
        title: "Grid",
        layoutType: "grid",
    },
    {

        icon: post_thumbnails,
        title: "Thumbnails",
        layoutType: "thumbnails",
    }
]